import React, { useState } from "react";

const heroImg = `url("https://images.pexels.com/photos/1382393/pexels-photo-1382393.jpeg")`;
const aboutImg = `url("https://images.pexels.com/photos/10526919/pexels-photo-10526919.jpeg")`;

const p = {
  lightest: "#d9e5d7",
  light: "#bfcfbb",
  mid: "#8ea58c",
  dark: "#738a6e",
  darkest: "#344c3d",
  accent: "#ffb5ca",
  white: "#fafcfa",
};

const services = {
  aged: {
    title: "Support at Home — Aged Care Services",
    subtitle: "Associated Provider Model with all inclusive pricing",
    items: [
      "Wellness and reablement approach",
      "Delivery of therapy under Strengthened Quality Standards",
      "Equipment prescriptions via AT-HM",
      "Ramps and rails home modifications",
      "Care plan writing, review and support",
      "Pressure injury review and prevention",
      "Cognitive assessments",
      "Skill-building to support independence",
      "Dementia care and environmental set up",
      "Falls prevention review and intervention",
      "Family and carer training and support",
      "Quality of life support",
    ],
  },
  ndis: {
    title: "NDIS Supports",
    subtitle: "Adult clients only",
    items: [
      "Executive functioning support, eg: organisational skills",
      "Daily activities of daily living, eg: cooking, housework",
      "Job preparation support",
      "Ramps and rails home modifications",
      "Low-cost assistive technology",
      "Functional capacity assessments",
      "Report writing",
      "Telehealth and home visit options available",
    ],
  },
};

const navLinks = ["About", "Services", "Location", "Contact", "Refer"];
const styles = `
  html { color-scheme: light only; }
  * { -webkit-color-scheme: light; color-scheme: light; }
  @media (max-width: 768px) {
    .nav-links { display: none !important; }
    .nav-links.open { display: flex !important; flex-direction: column; position: absolute; top: 64px; left: 0; right: 0; background: #344c3d; padding: 16px 24px; gap: 16px !important; box-shadow: 0 8px 24px rgba(52,76,61,0.2); z-index: 99; }
    .hamburger { display: flex !important; }
    .nav-title { font-size: 0.82rem !important; }
    .hero-box { padding: 28px 24px !important; }
    .hero-title { font-size: 1.8rem !important; }
    .hero-text { font-size: 0.88rem !important; }
    .about-inner { flex-direction: column !important; gap: 28px !important; }
    .about-photo { width: 160px !important; height: 160px !important; align-self: center; }
    .services-grid { grid-template-columns: 1fr !important; }
    .location-inner { flex-direction: column !important; gap: 28px !important; }
    .location-img { width: 100% !important; }
    .section-pad { padding: 48px 24px !important; }
    .contact-form { padding: 24px 20px !important; }
    .footer-inner { flex-direction: column !important; gap: 6px; text-align: center; }
    .refer-box { padding: 28px 20px !important; }
    .contact-links { flex-direction: column !important; align-items: center; gap: 12px !important; }
  }
`;

function Nav({ scrollTo }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNav = (id) => {
    scrollTo(id);
    setMenuOpen(false);
  };

  return (
    <>
      <style>{styles}</style>
      <nav style={{
        background: p.darkest,
        padding: "0 40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: 64,
        position: "sticky",
        top: 0,
        zIndex: 100,
        boxShadow: "0 2px 12px rgba(52,76,61,0.18)",
      }}>
        <span className="nav-title" style={{
          color: p.lightest,
          fontFamily: "'Georgia', serif",
          fontSize: "1rem",
          fontWeight: "bold",
          letterSpacing: "0.02em",
        }}>
          Kristina Sukhushina Occupational Therapy
        </span>

        {/* Desktop links */}
        <div className="nav-links" style={{ display: "flex", gap: 28 }}>
          {navLinks.map(link => (
            <button key={link} onClick={() => handleNav(link.toLowerCase())}
              style={{
                background: "none", border: "none", color: p.lightest,
                fontFamily: "'Georgia', serif", fontSize: "0.88rem",
                cursor: "pointer", padding: "4px 0",
                borderBottom: "1.5px solid transparent",
                transition: "border-color 0.2s",
                letterSpacing: "0.04em",
              }}
              onMouseEnter={e => e.target.style.borderBottomColor = p.accent}
              onMouseLeave={e => e.target.style.borderBottomColor = "transparent"}
            >{link}</button>
          ))}
        </div>

        {/* Hamburger button */}
        <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          style={{
            display: "none",
            flexDirection: "column", gap: 5,
            background: "none", border: "none",
            cursor: "pointer", padding: 8,
          }}
        >
          <div style={{ width: 22, height: 2, background: p.lightest, borderRadius: 2 }} />
          <div style={{ width: 22, height: 2, background: p.lightest, borderRadius: 2 }} />
          <div style={{ width: 22, height: 2, background: p.lightest, borderRadius: 2 }} />
        </button>
      </nav>

      {/* Mobile dropdown */}
      <div className={`nav-links${menuOpen ? " open" : ""}`} style={{ display: "none" }}>
        {navLinks.map(link => (
          <button key={link} onClick={() => handleNav(link.toLowerCase())}
            style={{
              background: "none", border: "none", color: p.lightest,
              fontFamily: "'Georgia', serif", fontSize: "1rem",
              cursor: "pointer", padding: "8px 0",
              borderBottom: `1px solid rgba(217,229,215,0.15)`,
              textAlign: "left", letterSpacing: "0.04em",
            }}
          >{link}</button>
        ))}
      </div>
    </>
  );
}

function Hero() {
  return (
    <section style={{
      backgroundImage: heroImg,
      backgroundSize: "cover",
      backgroundPosition: "center",
      padding: "90px 60px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    }}>
      <div className="hero-box" style={{
        background: "rgba(34,58,40,0.85)",
        borderRadius: 18,
        padding: "48px 56px",
        maxWidth: 600,
        width: "100%",
        boxSizing: "border-box",
      }}>
        <div style={{
          display: "inline-block",
          background: p.accent,
          color: p.darkest,
          borderRadius: 20,
          padding: "4px 16px",
          fontSize: "0.75rem",
          fontFamily: "sans-serif",
          letterSpacing: "0.12em",
          textTransform: "uppercase",
          marginBottom: 20,
        }}>Occupational Therapy</div>
        <h1 className="hero-title" style={{
          color: p.lightest,
          fontFamily: "'Georgia', serif",
          fontSize: "2.6rem",
          margin: "0 0 18px",
          lineHeight: 1.25,
        }}>
          Supporting <span style={{ color: p.accent, fontStyle: "italic" }}>Quality of Life</span>
        </h1>
        <p className="hero-text" style={{
          color: "rgba(217,229,215,0.88)",
          fontFamily: "sans-serif",
          fontSize: "1rem",
          lineHeight: 1.7,
          marginBottom: 0,
        }}>
          Aged care and NDIS occupational therapy services tailored to help you or your loved one live life to the fullest.
        </p>
      </div>
    </section>
  );
}

function About() {
  return (
    <section id="about" className="section-pad" style={{
      backgroundImage: aboutImg,
      backgroundSize: "cover",
      backgroundPosition: "center",
      padding: "80px 60px",
    }}>
      <div className="about-inner" style={{ maxWidth: 1000, margin: "0 auto", display: "flex", gap: 60, alignItems: "center" }}>
        <div style={{
          flex: 1,
          background: "rgba(250,252,250,0.92)",
          borderRadius: 18,
          padding: "40px",
          boxShadow: "0 4px 32px rgba(52,76,61,0.12)",
        }}>
          <div style={{ background: p.mid, width: 40, height: 3, borderRadius: 2, marginBottom: 16 }} />
          <h2 style={{ fontFamily: "'Georgia', serif", color: p.darkest, fontSize: "1.9rem", margin: "0 0 20px" }}>About Kristina</h2>
          <p style={{ color: "#3a3a3a", fontFamily: "sans-serif", lineHeight: 1.8, fontSize: "0.95rem", marginBottom: 16 }}>
            Hello! My name is Kristina, I am an occupational therapist based in Perth, WA. I am passionate about supporting older adults to maximise their quality of life. In my work, I focus on empowering clients through evidence-based practice and real connection. I offer a calm and warm approach to therapy sessions.
          </p>
          <p style={{ color: "#3a3a3a", fontFamily: "sans-serif", lineHeight: 1.8, fontSize: "0.95rem", opacity: 0.8 }}>
            My professional background involves working within residential aged care facilities, transitional care facilities and working in community NDIS with adult clients. As at 2026, I will be undergoing qualification to become a driver trained occupational therapist.
          </p>
        </div>
        <div className="about-photo" style={{
          flexShrink: 0, width: 220, height: 220, borderRadius: "50%",
          background: p.light, border: "none",
          display: "flex", alignItems: "center", justifyContent: "center",
          flexDirection: "column", gap: 8,
          boxShadow: "0 8px 32px rgba(52,76,61,0.18)",
          overflow: "hidden",
        }}>
          <img src="https://i.imgur.com/RHLTBf8.png" alt="Kristina" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }} />
        </div>
      </div>
    </section>
  );
}

function Services() {
  return (
    <section id="services" className="section-pad" style={{
      background: "linear-gradient(180deg, #d9e5d7 0%, #bfcfbb 100%)",
      padding: "80px 60px",
    }}>
      <div style={{ maxWidth: 1000, margin: "0 auto" }}>
        <div style={{ background: p.mid, width: 40, height: 3, borderRadius: 2, marginBottom: 16 }} />
        <h2 style={{ fontFamily: "'Georgia', serif", color: p.darkest, fontSize: "1.9rem", margin: "0 0 40px" }}>Services</h2>
        <div className="services-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 28 }}>
          <div style={{ background: p.white, borderRadius: 16, padding: "32px 28px", borderTop: `4px solid ${p.mid}`, boxShadow: "0 2px 20px rgba(52,76,61,0.07)" }}>
            <h3 style={{ fontFamily: "'Georgia', serif", color: p.darkest, fontSize: "1.1rem", margin: "0 0 6px", lineHeight: 1.4 }}>{services.aged.title}</h3>
            <p style={{ fontFamily: "sans-serif", fontSize: "0.8rem", color: p.dark, marginBottom: 20, marginTop: 0, fontStyle: "italic" }}>{services.aged.subtitle}</p>
            <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
              {services.aged.items.map((item, i) => (
                <li key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, fontFamily: "sans-serif", fontSize: "0.87rem", color: "#3a3a3a", lineHeight: 1.6, padding: "5px 0", borderBottom: i < services.aged.items.length - 1 ? `1px solid ${p.lightest}` : "none" }}>
                  <span style={{ color: p.mid, flexShrink: 0, marginTop: 3 }}>●</span>{item}
                </li>
              ))}
            </ul>
          </div>
          <div style={{ background: p.white, borderRadius: 16, padding: "32px 28px", borderTop: `4px solid ${p.accent}`, boxShadow: "0 2px 20px rgba(52,76,61,0.07)" }}>
            <h3 style={{ fontFamily: "'Georgia', serif", color: p.darkest, fontSize: "1.1rem", margin: "0 0 6px" }}>{services.ndis.title}</h3>
            <p style={{ fontFamily: "sans-serif", fontSize: "0.8rem", color: p.dark, marginBottom: 20, marginTop: 0, fontStyle: "italic" }}>{services.ndis.subtitle}</p>
            <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
              {services.ndis.items.map((item, i) => (
                <li key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, fontFamily: "sans-serif", fontSize: "0.87rem", color: "#3a3a3a", lineHeight: 1.6, padding: "5px 0", borderBottom: i < services.ndis.items.length - 1 ? `1px solid ${p.lightest}` : "none" }}>
                  <span style={{ color: p.accent, flexShrink: 0, marginTop: 3 }}>●</span>{item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

function Location() {
  const [zoomed, setZoomed] = useState(false);
  return (
    <section id="location" className="section-pad" style={{
      backgroundImage: aboutImg,
      backgroundSize: "cover",
      backgroundPosition: "center",
      padding: "80px 60px",
    }}>
      <div className="location-inner" style={{ maxWidth: 1000, margin: "0 auto", display: "flex", gap: 60, alignItems: "center" }}>
        <div style={{
          flex: 1,
          background: "rgba(250,252,250,0.92)",
          borderRadius: 18,
          padding: "40px",
          boxShadow: "0 4px 32px rgba(52,76,61,0.12)",
        }}>
          <div style={{ background: p.mid, width: 40, height: 3, borderRadius: 2, marginBottom: 16 }} />
          <h2 style={{ fontFamily: "'Georgia', serif", color: p.darkest, fontSize: "1.9rem", margin: "0 0 16px" }}>Location</h2>
          <p style={{ color: "#3a3a3a", fontFamily: "sans-serif", lineHeight: 1.8, fontSize: "0.95rem", marginBottom: 12 }}>
            Based in <strong>Perth, Western Australia</strong>, providing occupational therapy services across the <strong>Northern Suburbs</strong>.
          </p>
          <p style={{ color: "#3a3a3a", fontFamily: "sans-serif", lineHeight: 1.8, fontSize: "0.95rem", marginBottom: 24, opacity: 0.85 }}>
            Servicing areas ranging from <strong>Karrinyup to Ellenbrook to Yanchep</strong>, with home visits and telehealth options available.
          </p>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 10, background: p.accent, borderRadius: 12, padding: "12px 20px" }}>
            <span style={{ fontSize: "1.2rem" }}>📍</span>
            <span style={{ fontFamily: "sans-serif", fontSize: "0.88rem", color: "#fff", fontWeight: "600" }}>
              Perth <em>Northern Suburbs</em>, WA
            </span>
          </div>
        </div>
        <div>
          <img
            className="location-img"
            src="https://i.imgur.com/tSlGy2f.png"
            alt="Location"
            onClick={() => setZoomed(true)}
            style={{
              width: 280,
              alignSelf: "stretch",
              borderRadius: 16,
              boxShadow: "0 4px 24px rgba(52,76,61,0.13)",
              border: `2px solid ${p.light}`,
              objectFit: "cover",
              cursor: "zoom-in",
              display: "block",
            }}
          />
          {zoomed && (
            <div
              onClick={() => setZoomed(false)}
              style={{
                position: "fixed", top: 0, left: 0,
                width: "100vw", height: "100vh",
                background: "rgba(0,0,0,0.85)",
                display: "flex", alignItems: "center",
                justifyContent: "center", zIndex: 1000,
                cursor: "zoom-out",
              }}
            >
              <img
                src="https://i.imgur.com/tSlGy2f.png"
                alt="Location zoomed"
                style={{ maxWidth: "90vw", maxHeight: "90vh", borderRadius: 12 }}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

function Contact() {
  return (
    <section id="contact" className="section-pad" style={{ background: p.white, padding: "80px 60px" }}>
      <div style={{ maxWidth: 600, margin: "0 auto", textAlign: "center" }}>
        <div style={{ background: p.mid, width: 40, height: 3, borderRadius: 2, marginBottom: 16, display: "inline-block" }} />
        <h2 style={{ fontFamily: "'Georgia', serif", color: p.darkest, fontSize: "1.9rem", margin: "0 0 12px" }}>Get in Touch</h2>
        <p style={{ color: "#3a3a3a", fontFamily: "sans-serif", fontSize: "0.93rem", lineHeight: 1.7, marginBottom: 36, opacity: 0.8 }}>
          I'd love to hear from you.
        </p>
        <form action="https://formspree.io/f/mreykdpl" method="POST" className="contact-form" style={{ background: "#fff", borderRadius: 16, padding: "36px 40px", boxShadow: "0 2px 24px rgba(52,76,61,0.08)", textAlign: "left", border: `1px solid ${p.lightest}` }}>
          {[
            { label: "Your Name", type: "text", placeholder: "Chris P. Bacon", name: "name" },
            { label: "Email Address", type: "email", placeholder: "you@example.com", name: "email" },
            { label: "Phone (optional)", type: "tel", placeholder: "+61 4xx xxx xxx", name: "phone" },
          ].map(field => (
            <div key={field.label} style={{ marginBottom: 18 }}>
              <label style={{ display: "block", fontFamily: "sans-serif", fontSize: "0.8rem", color: p.darkest, marginBottom: 6, fontWeight: "600" }}>{field.label}</label>
              <input type={field.type} name={field.name} placeholder={field.placeholder} style={{ width: "100%", padding: "10px 14px", border: `1.5px solid ${p.light}`, borderRadius: 8, fontFamily: "sans-serif", fontSize: "0.88rem", color: "#3a3a3a", background: p.white, boxSizing: "border-box", outline: "none" }} />
            </div>
          ))}
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: "block", fontFamily: "sans-serif", fontSize: "0.8rem", color: p.darkest, marginBottom: 6, fontWeight: "600" }}>Message</label>
            <textarea name="message" rows={4} placeholder="How can I help you?" style={{ width: "100%", padding: "10px 14px", border: `1.5px solid ${p.light}`, borderRadius: 8, fontFamily: "sans-serif", fontSize: "0.88rem", color: "#3a3a3a", background: p.white, boxSizing: "border-box", resize: "vertical", outline: "none" }} />
          </div>
          <button style={{ width: "100%", background: p.darkest, color: p.lightest, border: "none", borderRadius: 30, padding: "13px", fontSize: "0.95rem", fontFamily: "sans-serif", cursor: "pointer" }}>Send Message</button>
        </form>
        <div className="contact-links" style={{ marginTop: 28, display: "flex", justifyContent: "center", gap: 24 }}>
          <a href="mailto:ot.kristina@outlook.com" style={{ color: p.darkest, fontFamily: "sans-serif", fontSize: "0.85rem", textDecoration: "none", display: "flex", alignItems: "center", gap: 6 }}>📧 ot.kristina@outlook.com</a>
          <a href="https://placeholder.com" style={{ background: p.accent, color: "#fff", fontFamily: "sans-serif", fontSize: "0.85rem", textDecoration: "none", padding: "6px 18px", borderRadius: 20, display: "flex", alignItems: "center", gap: 6 }}>📅 Online Bookings Coming Soon</a>
        </div>
      </div>
    </section>
  );
}

function Refer() {
  return (
    <section id="refer" className="section-pad" style={{
      backgroundImage: heroImg,
      backgroundSize: "cover",
      backgroundPosition: "center top",
      padding: "70px 60px",
      textAlign: "center",
    }}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <div className="refer-box" style={{ background: "rgba(34,58,40,0.85)", borderRadius: 18, padding: "48px" }}>
          <h2 style={{ fontFamily: "'Georgia', serif", color: p.lightest, fontSize: "1.9rem", margin: "0 0 16px" }}>Make a Referral</h2>
          <p style={{ color: "rgba(217,229,215,0.85)", fontFamily: "sans-serif", fontSize: "0.93rem", lineHeight: 1.7, marginBottom: 32 }}>
            See referral form below. Please get in touch directly if you have any questions.
          </p>
          <div style={{ position: "relative", width: "100%", height: 800, borderRadius: 14, overflow: "hidden" }}>
            <iframe
              src="https://kristina-sukhushina-occupational-therapy.splose.com/public-form/fbef6df8-9f30-490b-bd2b-fac323727e86"
              name="embeddableForm"
              title="Referral Form"
              style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
              scrolling="auto"
              width="100%"
              height="100%"
              loading="lazy"
              frameBorder="0"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer style={{ background: p.darkest, padding: "24px 60px" }}>
      <div className="footer-inner" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ color: "rgba(217,229,215,0.5)", fontFamily: "sans-serif", fontSize: "0.78rem" }}>© 2026 Kristina Sukhushina Occupational Therapy</span>
        <span style={{ color: "rgba(217,229,215,0.4)", fontFamily: "sans-serif", fontSize: "0.75rem" }}>ABN 25 837 793 775</span>
      </div>
    </footer>
  );
}

export default function App() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div style={{ minHeight: "100vh" }}>
      <Nav scrollTo={scrollTo} />
      <Hero />
      <About />
      <Services />
      <Location />
      <Contact />
      <Refer />
      <Footer />
    </div>
  );
}